import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../api/client';

// 仪表盘：拉举报 + 帖子两个 list 各取 count 显示概览。V1 没专门 stats
// endpoint，所以前端取列表 count 凑。V1.5 加 /v1/admin/dashboard。
export default function DashboardPage() {
  const [reportsCount, setReportsCount] = useState<number | null>(null);
  const [postsCount, setPostsCount] = useState<number | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const [r, p] = await Promise.all([
          api<{ items?: unknown[] }>('/admin/community/reports?limit=200'),
          api<{ items?: unknown[] }>('/admin/community/posts?limit=200'),
        ]);
        setReportsCount(r.items?.length ?? 0);
        setPostsCount(p.items?.length ?? 0);
      } catch (e) {
        setErr((e as ApiError).message);
      }
    })();
  }, []);

  return (
    <div>
      <h1 style={{ marginTop: 0 }}>仪表盘</h1>
      <p style={{ color: '#888' }}>
        欢迎进入家理理 admin。V1 已上线模块：UGC 审核（举报队列 + 帖子审核）。
      </p>
      {err && (
        <div style={{ padding: 12, background: '#fee', color: '#d33', borderRadius: 6 }}>
          加载失败：{err}
        </div>
      )}
      <div style={S.cards}>
        <StatCard
          to="/reports"
          icon="🚨"
          label="待处理举报"
          value={reportsCount}
          tone="warn"
        />
        <StatCard
          to="/posts"
          icon="📝"
          label="可见帖子"
          value={postsCount}
          tone="info"
        />
      </div>

      <div style={{ marginTop: 32 }}>
        <h2 style={{ fontSize: 16 }}>常用入口</h2>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8, color: '#444' }}>
          <li><Link to="/reports">处理举报</Link>：用户上报的违规内容</li>
          <li><Link to="/posts">帖子审核</Link>：列出所有帖子并可下架</li>
        </ul>
      </div>

      <div style={{ marginTop: 32, fontSize: 12, color: '#999' }}>
        V1 范围功能。用户管理 / 运营素材 / 数据看板留 V1.5+。
      </div>
    </div>
  );
}

function StatCard({
  to,
  icon,
  label,
  value,
  tone,
}: {
  to: string;
  icon: string;
  label: string;
  value: number | null;
  tone: 'warn' | 'info';
}) {
  const border = tone === 'warn' ? '#f5a623' : '#1f9d8f';
  return (
    <Link to={to} style={{ ...S.card, borderTop: `3px solid ${border}` }}>
      <div style={{ fontSize: 28 }}>{icon}</div>
      <div style={S.value}>{value === null ? '…' : value}</div>
      <div style={S.label}>{label}</div>
    </Link>
  );
}

const S: Record<string, React.CSSProperties> = {
  cards: { display: 'flex', gap: 16, marginTop: 24 },
  card: {
    flex: 1,
    background: 'white',
    padding: 20,
    borderRadius: 8,
    textDecoration: 'none',
    color: 'inherit',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
  },
  value: { fontSize: 28, fontWeight: 700, marginTop: 8 },
  label: { fontSize: 13, color: '#666', marginTop: 4 },
};
